"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FissionUploadImg',
  props: {
    value: {
      type: String,
      default: ''
    },
    imageAccessDomain: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 2
    },
    limitUnit: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showPicVisible: false,
      uploadUrl: process.env.VUE_APP_PIM_API + 'xyFissionActivity/uploadImage'
    };
  },
  computed: {
    // 计算属性的 getter
    headers: function headers() {
      return {
        'X-Token': (0, _auth.getToken)()
      };
    }
  },
  created: function created() {},
  methods: {
    showPic: function showPic() {
      this.$refs.showBigPic.clickHandler();
      this.showPicVisible = true;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      var data = res.data;
      if (data) {
        this.$emit('input', data.pathKey);
      }
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      debugger;
      // 支持jpg/png格式
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var maxSize = this.limitUnit === 'MB' ? 1024 * 1024 : this.limitUnit === 'KB' ? 1024 : 1;
      var isLt = file.size / maxSize < this.limit;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 ' + this.limit + this.limitUnit + '!');
      }
      return isJPG && isLt;
    }
  }
};